import React, { Fragment } from 'react';
import Cart from './Cart';
import { translate } from '../Services/translation';
import CheckoutPopUp from './CheckoutPopUp';
import { useSelector } from 'react-redux';

const CheckoutCart = ({ errors, authenticated, loginPageUrl, registrationUrl, continueShoppingLinkUrl  }) => {
    const cart = useSelector((state) => state.cart);

    return (
        <Fragment>
            <div className="row">
                <div className="small-12 checkout__top-row">
                    {continueShoppingLinkUrl &&
                        <a className='checkout__go-back-button show-desktop' href={continueShoppingLinkUrl}>
                            {translate('coptikk.checkout.continue.shopping')}
                        </a>
                    }
                    <h2 className="checkout__title">
                        {translate('checkout.title')}
                    </h2>
                </div>
            </div>
            {!authenticated &&
                <CheckoutPopUp
                    loginPageUrl={loginPageUrl}
                    registrationUrl={registrationUrl}
                />
            }
            
            <div className="row checkout__go-back-row">
                {continueShoppingLinkUrl &&
                    <a className='checkout__go-back-button show-mobile' href={continueShoppingLinkUrl}>
                        {translate('coptikk.checkout.continue.shopping')}
                    </a>
                }
            </div>
            {cart.orderRows.length > 0 && cart.deliveryInformation && <div className='row checkout__delivery-message'>
                <h2 className="title">
                    {translate('coptikk.checkout.delivery.message')}
                </h2>
                <p className="text" dangerouslySetInnerHTML={{__html : cart.deliveryInformation}}>                    
                </p>
            </div>}
            {cart.isDummyTokenOrder && <div className='row checkout__delivery-message'>
                <h2 className="title">
                    {translate('coptikk.checkout.updatecard.header')}
                </h2>
                <p className="text">{translate('coptikk.checkout.updatecard.description')}</p>
            </div>

            }
            <div className="row checkout__section-title-row">
                <h3 className="checkout__section-title">
                    {translate('checkout.cart.title')}
                </h3>
            </div>
            <div className="row">
                {errors && errors['cart'] && (
                    <p className="checkout__validator--error">
                        {errors['cart'][0]}
                    </p>
                )}
            </div>
            <Cart authenticated={authenticated}/>
        </Fragment>
    );
};

export default CheckoutCart;